/**
 * SSR-safe rules for `r-accordion` motion and the custom chevron.
 *
 * widget-react injects this once per library via `ComponentLibraryModule.stylesheet`.
 * Open/close height and opacity cannot be inline styles: they key off `[open]`
 * and `::details-content`. The chevron rotate is the same. Hiding the UA
 * triangle belongs here too — `summary::marker` is a pseudo-element.
 *
 * Browsers that do not support `::details-content` / `interpolate-size` still
 * open and close; they just snap. The chevron and the disclosure keep working.
 */
export const ACCORDION_LIBRARY_STYLESHEET = `
[data-rulecms-accordion] {
  interpolate-size: allow-keywords;
}
[data-rulecms-accordion] > summary {
  list-style: none;
}
[data-rulecms-accordion] > summary::-webkit-details-marker {
  display: none;
}
[data-rulecms-accordion] > summary::marker {
  content: none;
}
[data-rulecms-accordion]::details-content {
  overflow: hidden;
  opacity: 0;
  block-size: 0;
  transition:
    block-size 300ms ease,
    opacity 300ms ease,
    content-visibility 300ms allow-discrete;
}
[data-rulecms-accordion][open]::details-content {
  opacity: 1;
  block-size: auto;
}
[data-rulecms-accordion-chevron] {
  transition: transform 300ms ease;
}
[data-rulecms-accordion][open] [data-rulecms-accordion-chevron] {
  transform: rotate(180deg);
}
`.trim();
